import { useAuth0 } from "@auth0/auth0-react";

const { REACT_APP_AUTH0_DOMAIN, REACT_APP_AUTH0_CLIENT } = process.env;

export default function useLogout() {

    const {
        user,
        logout,
    } = useAuth0();

    function getUserLoginMethod(user) {
        // Check if the user's profile contains identity information
        if (user && user.identities && user.identities.length > 0) {
            // Check the provider of the first identity (assuming it's the one used for login)
            const provider = user.identities[0].provider;
    
            if (provider === 'auth0') {
                return 'Auth0 Account';
            } else if (provider === 'microsoft') {
                return 'Microsoft Account';
            }
        }
        return 'Unknown';
    }
    
    const customLogout = async () => {
        localStorage.clear();
        window.location.href = `https://${REACT_APP_AUTH0_DOMAIN}/v2/logout?client_id=${REACT_APP_AUTH0_CLIENT}&returnTo=${encodeURIComponent('https://nice-desert-0c7c4a90f.5.azurestaticapps.net')}`;
    }

    return { customLogout };
}